import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./Components/Authorize/ProtectedRoute";
import AdminLayout from "./Components/Admin/AdminLayout";
import Dashboard from "./Components/Admin/Dashboard";
import AboutMeEditor from "./Components/Admin/AboutMeEditor";
import ResourceList from "./Components/Admin/ResourceList";
import ResourceForm from "./Components/Admin/ResourceForm";
import AdminNotFound from "./Components/Admin/AdminNotFound";
import { RESOURCES } from "./Components/Admin/resources";

// The public pages are loaded on demand so their global stylesheets (Resume.css,
// Login.css) are never on the page together with the admin template's CSS.
const ResumePage = lazy(() => import("./Components/Resume/ResumePage"));
const Login = lazy(() => import("./Components/Authorize/Login"));

const { skills, portfolio, experience, education, messages, users } = RESOURCES;

function App() {
  return (
    <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<ResumePage />} />
      <Route path="/login" element={<Login />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
            </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="about" element={<AboutMeEditor />} />

        <Route path="skills" element={<ResourceList key="skills" config={skills} />} />
        <Route path="skills/add" element={<ResourceForm key="skills-add" config={skills} />} />
        <Route path="skills/edit/:id" element={<ResourceForm key="skills-edit" config={skills} />} />

        <Route path="portfolio" element={<ResourceList key="portfolio" config={portfolio} />} />
        <Route path="portfolio/add" element={<ResourceForm key="portfolio-add" config={portfolio} />} />
        <Route path="portfolio/edit/:id" element={<ResourceForm key="portfolio-edit" config={portfolio} />} />

        <Route path="experience" element={<ResourceList key="experience" config={experience} />} />
        <Route path="experience/add" element={<ResourceForm key="experience-add" config={experience} />} />
        <Route path="experience/edit/:id" element={<ResourceForm key="experience-edit" config={experience} />} />

        <Route path="education" element={<ResourceList key="education" config={education} />} />
        <Route path="education/add" element={<ResourceForm key="education-add" config={education} />} />
        <Route path="education/edit/:id" element={<ResourceForm key="education-edit" config={education} />} />

        <Route path="messages" element={<ResourceList key="messages" config={messages} />} />

        <Route path="users" element={<ResourceList key="users" config={users} />} />
        <Route path="users/add" element={<ResourceForm key="users-add" config={users} />} />
        <Route path="users/edit/:id" element={<ResourceForm key="users-edit" config={users} />} />

        <Route path="*" element={<AdminNotFound />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </Suspense>
  );
}

export default App;
